import { Button, Col, Container, Pagination, Row, Table } from "react-bootstrap"
import { useEffect, useState } from "react"
import NoResults from "../app/components/NoResults"
import Loader from "../app/components/Loader"
import addImage from "../../assets/images/app/add.svg"
import AddEdit from "./components/AddEdit"
import { useUsersDataContext } from "./providers/users"
import User from "./components/User"

function Users() {

    const users = useUsersDataContext()
    const { getUsers, refetchData, getCurrentPage, setPage, loading } = users
    const [modalShow, setModalShow] = useState(false)

    function changePage(newPage) {
        setPage(newPage)
    }

    const currentPage = getCurrentPage();
    const totalPages = getUsers().pages;

    function createPagination() {
        const pageItems = [];

        // Always show the first page
        pageItems.push(
            <Pagination.Item key={1} active={1 === parseInt(currentPage)} onClick={() => changePage(1)}>
                1
            </Pagination.Item>
        );

        // Show ellipsis after the first page if necessary
        if (currentPage > 3) {
            pageItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
        }

        // Show current page and next 2 pages (if they exist) dynamically
        const startPage = Math.max(2, parseInt(currentPage) - 1); // Start from current page or 2 if close to the start
        const endPage = Math.min(parseInt(currentPage) + 2, parseInt(totalPages) - 1); // Ensure no more than 2 pages after the current one

        for (let number = startPage; number <= endPage; number++) {
            pageItems.push(
                <Pagination.Item key={number} active={number === currentPage} onClick={() => changePage(number)}>
                    {number}
                </Pagination.Item>
            );
        }

        // Show ellipsis before the last page if necessary
        if (parseInt(currentPage) + 2 < parseInt(totalPages) - 1) {
            pageItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
        }

        // Always show the last page if there are more than one page
        if (totalPages > 1) {
            pageItems.push(
                <Pagination.Item key={totalPages} active={totalPages === currentPage} onClick={() => changePage(totalPages)}>
                    {totalPages}
                </Pagination.Item>
            );
        }

        return pageItems;
    }

    function renderTable() {
        return (
            <section>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th style={{ width: '15%' }}>
                                Име и фамилия
                            </th>
                            <th style={{ width: '20%' }}>
                                Е-Поща
                            </th>
                            <th style={{ width: '10%' }}>
                                Телефонен номер
                            </th>
                            <th style={{ width: '30%' }}>
                                Адрес
                            </th>
                            <th style={{ width: '15%' }}>
                                Метод на регистрация:
                            </th>
                            <th style={{ width: '10%' }}>
                                Опции
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {getUsers().data.map((c) => (
                            <User page={getCurrentPage()} key={c.id} data={c} />
                        ))}
                    </tbody>
                </Table>
                <div>
                    {totalPages > 1 ? (
                        <Pagination style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} centered>
                            {createPagination()}
                        </Pagination>
                    ) : null}
                </div>
            </section>
        )
    }
    function results() {
        return totalPages > 0 ? renderTable() : <NoResults type={'users'} />
    }


    return (
        <>
            <Container fluid="true" style={{ marginBottom: '25px' }}>
                <Row style={{ width: '100%' }}>
                    <Col style={{ marginLeft: '5px' }}>
                        <h1>Потребители</h1>
                    </Col>
                    {/* <Col style={{marginRight:'5px'}}> Звучи безполезно да добавяш потребител от админ панела
                            <Button onClick={() => setModalShow(true)}  variant="success" style={{ float: 'right', marginTop: '10px' }} >
                                <img style={{ margin: '3px', marginRight: '6px' }} src={addImage} />Добави Потребител
                            </Button>
                        </Col> */}
                </Row>
            </Container>
            {users.loading == false ? results() : <Loader />}
            <AddEdit
                show={modalShow}
                onHide={() => setModalShow(false)}
                data={null}
                type={'add'}
            />
        </>

    )
}
export default Users